import * as types from "../actions/ActionTypes";

export default function Agencydelete(state = false, action) {
  const { type, payload } = action;

  switch (type) {
    case types.AGENCY_DELETE:
      return (state = payload);
    default:
      return state;
  }
}
